import store from "@/store";
import axios from "axios";

import Jsona from 'jsona';
const jsona = new Jsona();

export default async function permission({ to, next }) {
    const requiredPermission = to.meta.permission;

    // if no permission is required → allow
    if (!requiredPermission) {
        return next();
    }

    // if not authenticated → allow (auth middleware will redirect)
    if (!store.getters["isAuthenticated"]) {
        return next();
    }

    // if authUser not loaded yet → load it
    if (!store.state.auth.authUser) {
        try {
            const res = await axios.get(`${process.env.VUE_APP_API_BASE_URL}/me?include=roles,person,person.contacts`);
            store.commit("setAuthUser", jsona.deserialize(res.data));
        } catch (e) {
            return next({ name: "Login" });
        }
    }

    const permissions = store.state.auth.authUser?.permissions || [];

    if (permissions.includes(requiredPermission)) {
        return next();
    }

    // no permission → redirect to Unauthorized page
    return next({ name: "Unauthorized" });
}
